import { useStore } from 'effector-react'
import { balanceModel } from '~/entities/Balance'
import { PlusIcon } from '~/shared/ui/icons'
import { Button } from './styled'

export function AddCardButton() {
  const isGetAddLinkLoading = useStore(balanceModel.getAddLinkFx.pending)
  const addLink = useStore(balanceModel.$addLink) || ''

  return (
    <Button
      href={addLink}
      //eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      target='_blank'
      fullWidth
      variant='lightSteelBlueBorder'
      startDecorator={<PlusIcon />}
      size='large'
      loading={isGetAddLinkLoading}
      disabled={!addLink}
    >
      Добавить карту
    </Button>
  )
}
